export const GET_NEWS = 'GET_NEWS';
export const SET_NEWS = 'SET_NEWS';
export const ERROR_NEWS = 'ERROR_NEWS';
